export const ErrorInformationAlert = ({ show, errors }) => {
  // Check if the errors object is empty
  const hasErrors = Object.keys(errors).length > 0;

  return (
    show &&
    hasErrors && (
      <div className="col-span-6 mt-5 sm:col-span-6">
        <div className="space-y-1 text-sm text-slate-300">
          <p className="text-amber-300">
            Please ensure you input the right information.
          </p>
          {Object.keys(errors).map((key) => (
            <p className="text-amber-300" key={key}>
              - {errors[key]}
            </p>
          ))}
        </div>
      </div>
    )
  );
};
